import React, { useState, useEffect, useRef } from "react";
//import MeetingInformation from '../MeetingInformation';
import { Box, CardHeader, Grid, Typography } from "@material-ui/core";
import { Card, CardContent } from "@material-ui/core";
import MeetingInformation from "../components/MeetingInformation";
import JoinMethod from "../components/joiningmethod";

import { useNavigate, useParams } from "react-router";
import { Get, Create } from "../../../actions";
import {
  Post_PowerOfAttorney_URL,
  Post_JoinMeeting_URL,
  Get_MeetingInfo_URL,
  Get_PowerOfAttorney_URL,
  Get_MeetingMember_URL,
  Get_CompanyInfo_URL,
  Get_AllMeetingAgendas_URL,
  Get_Files_URL,
  Get_MeetingGetAllMeetingMembers,
} from "../../../constants/apiUrls";
import { useSnackbar } from "notistack";
import { InvitationPrint } from "..";
import { useReactToPrint } from "react-to-print";
import * as Yup from "yup";
import { useOutletContext } from "react-router-dom";
import { CompanyInformation } from "../components";
import { AskAgendaList } from "./askAgendaList";
import { UploadFiles } from "../../../components/Upload";
import { getTranslation } from "../../../heplers/translationHelper";
import TableComponent from "../../../components/table";


const columns = [
  {
    id: "fullName",
    numeric: false,
    disablePadding: true,
    label: getTranslation("Name", "Name", "Name"),
  },
  {
    id: "mail",
    numeric: false,
    disablePadding: true,
    label: getTranslation("Mail", "Mail", "Mail"),
  },
  {
    id: "phone1",
    numeric: false,
    disablePadding: true,
    label: getTranslation("Phone", "Phone", "Phone"),
  },
  {
    id: "representativeStatusText",
    numeric: false,
    disablePadding: true,
    label: getTranslation("Join Status", "Join Status", "Join Status"),
  },
  // {
	// id:"isSigned",
	// label:getTranslation("Is Signed?", "Is Signed?", "Is Signed?"),
	// component:({row})=><Typography>{row?.isSigned ? "Signed" : row?.isNeededSignature==false ? "Not Required" : "Not Signed"}</Typography>
  // }
];


export const JoinMeeting = () => {
  const [handleAlredyGenerated] = useOutletContext();

  const [enablePrint, setEnablePrint] = useState(false);
  const { meetingId, meetingMemberId } = useParams();
  const [POId, setPOId] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const [powerOfAttorney, setPowerOfAttorney] = useState();
  ///////////////////////////////////////////// Submit Join Meeting Method //////////////////////////////////
  const [printDocument, setPrintDocument] = useState(false);
  const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
  
  const handleSubmit = (values, actions) => {
    setPowerOfAttorney(values);
    Create(
      values,
      values.enablePowerOfAttorney
        ? Post_PowerOfAttorney_URL
        : Post_JoinMeeting_URL,
      history,
      (resp) => {
        setPOId(resp?.data);
        actions.setSubmitting(false);
        enqueueSnackbar(resp.data, { variant: "success" });
        if (values.enablePowerOfAttorney) {
          setPrintDocument(true);
        }
      },
      (error) => {
        enqueueSnackbar(error?.data, { variant: "warning" });
        actions.setSubmitting(false);
      }
    );
  };

  useEffect(() => {
    if (POId && printDocument) {
      handlePrint();
    }
  }, [POId, printDocument]);

  /////////////////////////////////////////////////// Get Meeting Information  /////////////////////////////

  const [meetingInfo, setMeetingInfo] = useState();
	const [companyInfo, setCompanyInfo] = useState({});
  const [agendas, setAgendas] = useState([]);
	const [meetingDocuments, setMeetingDocuments] = useState([]);
	const [attendaant, setAttendants] = useState([]);

  const history = useNavigate();

  useEffect(() => {
    loadMeetingInfo({
      meetingId: meetingId,
    });
    Get(
      {
        meetingId: meetingId,
      },
      Get_AllMeetingAgendas_URL,
      history,
      (resp) => {
        setAgendas(resp?.data);
        // handleAlredyGenerated();
      },
      (error) => {}
    );
  }, [meetingId]);
  const loadMeetingInfo = (values) => {
    Get(
      values,
      Get_MeetingInfo_URL,
      history,
      (resp) => {
        setMeetingInfo(resp?.data);
        // handleAlredyGenerated();
      },
      (error) => {}
    );
  };
  /////////////////////////////////////////////////// Get Personal Information  /////////////////////////////
  const [personalInfo, setPersonalInfo] = useState();
  useEffect(() => {
    loadPersonalInfo({
      id: meetingMemberId,
    });
    Get(
      {
        meetingId: meetingId,
      },
      Get_CompanyInfo_URL,
      null,
      (resp) => {
        setCompanyInfo(resp?.data);
      },
      (error) => {}
    );
    Get(
			{
				meetingId: meetingId,
			},
			Get_Files_URL,
			null,
			(resp) => {
				setMeetingDocuments(resp?.data);
			},
			(error) => {}
		);
    Get(
			{
				meetingId: meetingId,
			},

			Get_MeetingGetAllMeetingMembers,

			null,
			(list) => {
				setAttendants(list.data);
				
			},
			(error) => {
				console.log("parse table user  error");
			}
		);
  }, [meetingMemberId]);
  const loadPersonalInfo = (values) => {
    Get(
      values,
      Get_MeetingMember_URL,
      history,
      (resp) => {
        setPersonalInfo(resp?.data);
      },
      (error) => {
        enqueueSnackbar(error?.data, { variant: "error" });
      }
    );
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    documentTitle: "Invitation",
    content: () => componentRef.current,
  });

  const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};
	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value));
		setPage(0);
	};

  return (
    <>
      <Card>
        <CardContent>
          <CompanyInformation meetingId={meetingId} companyInfo={companyInfo} />
          <br />
          <br />
          <MeetingInformation meetingId={meetingId} meetingInfo={meetingInfo} />
          <br />
          <br />
          <AskAgendaList agendaList={agendas} meetingId={meetingId} />

          <br />
          <br />

          <Card>
            <CardHeader
              title={getTranslation(
                "Uploaded Files",
                "Fichiers téléchargés",
                "Hochgeladene Dateien"
              )}
            />
            <CardContent>
              <UploadFiles
                disabled
                uploadedFiles={meetingDocuments}
                getFileName={(file) => {
                  return file.fileName;
                }}
              />
            </CardContent>
          </Card>

          <br />
          <br />
          <TableComponent
            dense
            auto
            title={getTranslation("Attendants", "Attendants", "Attendants")}
            colums={columns}
            count={attendaant?.length}
            rows={attendaant}
            page={0}
            rowsPerPage={10}
			handleChangePage={(event, newPage) =>
				handleChangePage(event, newPage)
			  }
			  handleChangeRowsPerPage={(e) => handleChangeRowsPerPage(e)}
          />
          <br />
          <br />
          <JoinMethod
            meetingMemberId={meetingMemberId}
            onSubmit={handleSubmit}
          />
        </CardContent>
      </Card>

      <div style={{ display: "none" }}>
        <InvitationPrint
          ref={componentRef}
          meetingInfo={meetingInfo}
          personalInfo={personalInfo}
          powerOfAttorneyId={POId}
          powerOfAttorney={powerOfAttorney}
        />
      </div>
    </>
  );
};
